import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useFlags, useLabels, useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { selectIsTabbedLayout } from '../../../../features/layoutSlice';
import { enableModernMyCarsFlag } from '../../../../global-constants';
import { publishVehicleData } from '../../../../utilities/vehicleTracking';
import ModernMyCarsDetails from './ModernMycarsDetails';
import LegacyMyCarsDetails from './LegacyMyCarsDetails';
import { useDeviceType } from '../../../../hooks';

const DetailsButton = ({ uuid, link }) => {
	const flags = useFlags();
	const labels = useLabels();
	const isDesktop = useDeviceType();
	const { windowId, widgetName } = useRequestData();
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));
	const { useSimplifiedListing } = useSelector((state) => state.layout);
	const isInline = !isTabbedLayout;
	const enableModernMyCars = flags[enableModernMyCarsFlag];

	const handleClick = () => {
		trackEvent(widgetName, windowId, {
			element: 'View details link',
			result: 'Navigated to VDP'
		});
		publishVehicleData(uuid);
	};

	return enableModernMyCars ? (
		<ModernMyCarsDetails
			link={link}
			onClick={handleClick}
			label={labels.get('DETAILS')}
			isInline={isInline}
		/>
	) : (
		<LegacyMyCarsDetails
			link={link}
			onClick={handleClick}
			isDesktop={useSimplifiedListing && isDesktop}
			label={
				useSimplifiedListing
					? labels.get('DETAILS')
					: labels.get('MORE_DETAILS')
			}
		/>
	);
};

DetailsButton.propTypes = {
	uuid: PropTypes.string,
	link: PropTypes.string
};

export default DetailsButton;
